import * as React from "react";
import { Languages } from "lucide-react";
import { ImageLoader } from "../../../ui/components/ImageLoader";
import { ListViewCard } from "../../../ui/components/ListView/components/ListViewCard";
import type {
  ListViewCardAction,
  ListViewCardLayout,
} from "../../../ui/components/ListView/components/ListViewCard";
import type { Language } from "../../lib/api/localization";
import { useI18n } from "../../lib/i18n";

export interface ListViewLanguageCardProps {
  layout: ListViewCardLayout;
  language: Language;
  contextActions?: ListViewCardAction[];
  onClick?: () => void;
  compact?: boolean;
}

export function ListViewLanguageCard({
  layout,
  language,
  contextActions,
  onClick,
  compact,
}: ListViewLanguageCardProps) {
  const { t } = useI18n();
  const image = language.flagUrl ? (
    <ImageLoader src={language.flagUrl} />
  ) : (
    <Languages size={layout === "deck" ? (compact ? 28 : 40) : compact ? 24 : 32} style={{ opacity: 0.55 }} />
  );

  const statusBadge = language.enabled
    ? {
        id: "status",
        label: t("pro.system.localization.status.enabled"),
        variant: "active" as const,
      }
    : {
        id: "status",
        label: t("pro.system.localization.status.disabled"),
        variant: "disabled" as const,
      };

  return (
    <ListViewCard
      id={language.id}
      layout={layout}
      imageFormat="cover"
      image={image}
      title={language.name}
      subtitle={language.code}
      footerText={language.description ?? undefined}
      badges={[statusBadge]}
      onClick={onClick}
      contextActions={contextActions}
      compact={compact}
    />
  );
}
